import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEOHead from "@/components/feature/SEOHead";
import HeroBanner from "./components/HeroBanner";
import CategoryShowcase from "./components/CategoryShowcase";
import TrendingSection from "./components/TrendingSection";
import ArticlePreview from "./components/ArticlePreview";
import NewsletterSection from "./components/NewsletterSection";

const homeSEO = {
  title: "日韩欧美风格一站式精选 - 潮流尽在此处",
  description:
    "探索日韩欧美最新潮流趋势，汇聚日韩欧美顶尖品牌与风格精华。无论你钟爱日系清新、韩系时尚还是欧美大气，这里一站满足，让你轻松驾驭多元国际风格，打造专属时尚态度。日韩欧美潮流、日韩欧美风格穿搭、日韩欧美品牌推荐、日韩欧美时尚趋势、日韩欧美爆款单品、日韩欧美购物指南。",
  keywords:
    "日韩欧美,日韩欧美潮流,日韩欧美风格穿搭,日韩欧美品牌推荐,日韩欧美时尚趋势,日韩欧美爆款单品,日韩欧美购物指南",
};

export default function HomePage() {
  const canonical = "https://ribenhanou-style.com/";
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "日韩欧美 Style Hub",
        url: "https://ribenhanou-style.com",
        description: homeSEO.description,
        sameAs: ["https://weibo.com/ribenhanou", "https://www.xiaohongshu.com/ribenhanou"],
      },
      {
        "@type": "WebSite",
        name: "日韩欧美 Style Hub",
        url: "https://ribenhanou-style.com",
        description: homeSEO.description,
        inLanguage: "zh-CN",
      },
      {
        "@type": "WebPage",
        name: homeSEO.title,
        description: homeSEO.description,
        url: canonical,
        isPartOf: { "@type": "WebSite", name: "日韩欧美 Style Hub" },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={homeSEO.title}
        description={homeSEO.description}
        keywords={homeSEO.keywords}
        canonicalUrl={canonical}
        ogImage="https://readdy.ai/api/search-image?query=Fashion%20style%20minimalist%20Japanese%20Korean%20European%20aesthetic%20collage%2C%20warm%20cream%20beige%20tones%2C%20soft%20natural%20lighting%2C%20editorial%20photography&width=1200&height=630&seq=home-og-2026&orientation=landscape"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryShowcase />
        <TrendingSection />
        <ArticlePreview />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}